module.exports = __webpack_public_path__ + "static/img/xiandaifuwu-2.6df39446.svg";